import { Grid } from '@mui/material';
import BoardroomHeader from '../../scenes/CompanyDashboardV2/BoardroomHeader';
import SwitchesTile from './SwitchesTile';

export default function TopSection() {
  return (
    <Grid container spacing={2}>
      <Grid item xxs={12} md={9}>
        <BoardroomHeader />
      </Grid>
      <Grid item xxs={12} md={3}>
        <SwitchesTile
          backgroundColor="#E5F3FF"
          width="100%"
          height="100%"
          marginTop="0px"
          ids={{
            paper: 'dashboard-account-panel',
            upgradeLink: 'dashboard-account-upgrade',
            inviteContacts: 'dashboard-invite-contacts',
            accessNetwork: 'dashboard-access-network',
            boardMeetings: 'dashboard-board-meetings',
          }}
        />
      </Grid>
    </Grid>
  );
}
